<template>
  <div class='contact-item'>
      <div @click="handleClick" class="graphic" :style="{ backgroundColor: bg }">
          <font-awesome-icon :icon="iconname" />
      </div>
      <div class="text">{{ text }}</div>
      <div class="valuelink"><a :href='href'>{{ link }}</a></div>
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  props: {
    iconname: { type: Object },
    text: { type: String },
    href: { type: String },
    link: { type: String },
    bg: { type: String }
  },
  mounted () {
  },
  data () {
    return {
    }
  },
  methods: {
    handleClick () {
      window.location.href = this.href
    }
  },
  components: { FontAwesomeIcon }
}
</script>

<style lang="less" scoped>

@import '../css/globals.less';

a:link {
  text-decoration: none;
}

div.contact-item {
  flex: 1 0 260px;
  display: flex;
  flex-direction: column;
  padding: .5em;
  align-items: center;
  justify-content: center;
}

div.contact-item div.graphic {
  display: flex;
  flex-direction: column;
  cursor: pointer;
  flex: 0 0 3rem;
  width: 3rem;
  height: 3rem;
  box-sizing: border-box;
  border-radius: 1.5rem;
  border: solid .1rem rgba(255, 255, 255, 0.22);
  background-color: rgb(255, 255, 255);
  transform: scale(0.8);
  transition: transform .2s ease-in-out;
}
div.contact-item div.graphic:hover {
  border: solid .1rem rgba(255, 255, 255, 0.835);
  transform: scale(1.2);
}

div.contact-item div.graphic svg {
  display: flex;
  align-items: center;
  color: rgb(255, 255, 255);
  vertical-align: middle;
  margin: auto;
  font-size: 1.5rem;
  width: 100%;
}


div.contact-item div.text {
  text-transform: uppercase;
  font-family: @serif-font;
  padding: 0.5em;
  text-align: center;
}

div.contact-item div.valuelink {
  text-transform: lowercase;
  font-family: @serif-font;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/ContactItem.vue